import React, { PureComponent } from "react";
import { withTranslation } from "react-i18next";
import { Dialog, withStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import styles from "./PaymentMethodDialog.module.scss";
import Button from "@material-ui/core/Button";
import Error from "../../imgs/error/error.png";
import UpperCaseText from "../../utils/UpperCaseText";
import CapitalizeText from "../../utils/CapitalizeText";

class CannotConvertDialog extends PureComponent {
  render() {
    const StyledDialog = withStyles({
      paper: {
        width: 600,
      },
    })(Dialog);

    return (
      <StyledDialog open={this.props.open} onClose={this.props.closeDialog}>
        <Grid container className={styles.cancelDialog}>
          <Grid item xs={12} className={styles.dialogHeaderGrid}>
            <img src={Error} className={styles.Error} />
            <div className={styles.dialogHeaderText}>
              {this.props.switchPaymentInProcessError
                ? this.props.t("Error.notSwitchPaymentMethod")
                : this.props.t("PaymentMethod.switchingPayment", {
                    type: UpperCaseText(this.props.paymentType),
                  })}
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={styles.dialogBody}>
              {this.props.switchPaymentInProcessError
                ? this.props.t("Error.notSwitchPaymentMethodBody")
                : this.props.t("PaymentMethod.looksLikeApplication", {
                    status: CapitalizeText(this.props.activeStatus),
                    type: this.props.paymentType,
                  })}
            </div>
          </Grid>
          <Grid item md={12} className={styles.dialogHeaderGrid}>
            <div>
              <Button
                data-testid="cancelErrorDialog"
                className={styles.cancelDialogButton}
                onClick={this.props.closeDialog}
              >
                {this.props.t("PaymentMethod.backButton")}
              </Button>
            </div>
          </Grid>
        </Grid>
      </StyledDialog>
    );
  }
}

export default withTranslation("emp")(CannotConvertDialog);
